/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Ec2KeyPairs { 
    /**
     * Key Pairs ID
     */
    id: string;
    /**
     * Key Pairs name
     */
    name: string;
    /**
     * Created timestamp in UTC
     */
    created_timestamp: Date;
}

